interface IColumnItem {
    index?: number,
    columnName?: string,
    checked: boolean,
    dragable: boolean,
    disabled: boolean,
    label: string,
    bracketsStr?: string,
    splicingLabel?: string,
    toLabel?: string,
}

interface IColumnTypes {
    tableName: string,
    tableColumnsList: IColumnItem[],
}

export const ColumnsTypes: IColumnTypes[] = [
    {
        tableName: 'lendingRepaymentPlanListTable',
        tableColumnsList: [{
            columnName: 'repaymentPlanNo',
            checked: true,
            dragable: false,
            disabled: true,
            label: 'Repayment Plan No.',
        }, {
            columnName: 'loanOrder',
            checked: true,
            dragable: false,
            disabled: true,
            label: 'Loan Order',
        }, {
            columnName: 'borrower',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Borrower',
        }, {
            columnName: 'collector',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Collector',
        }, {
            columnName: 'collectionStage',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Collection Stage',
        }, {
            columnName: 'helperStatus',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Helper Status',
        }, {
            columnName: 'chequeHandling',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Cheque Handling',
        }, {
            columnName: 'dueDate',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Due Date',
        }, {
            columnName: 'originalDueDateOnCheque',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Original Due Date on Cheque',
        }, {
            columnName: 'salaryDate',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Salary Date',
        }, {
            columnName: 'chequeNo',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Cheque No.',
        }, {
            columnName: 'contractNo',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Contract No.',
        }, {
            columnName: 'totalRepaymentAmount',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Total Repayment Amount',
        }, {
            columnName: 'followUpRecord',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Follow-up Record',
        }, {
            columnName: 'receivedAmount',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Received Amount',
        }, {
            columnName: 'unreceivedAmount',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Unreceived Amount',
        }, {
            columnName: 'ReceivableNo',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Receivable No.',
        }, {
            columnName: 'paymentStatus',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Payment Status',
        }, {
            columnName: 'remark',
            checked: true,
            dragable: false,
            disabled: true,
            label: 'Remark',
        }, {
            columnName: 'operation',
            checked: true,
            dragable: false,
            disabled: true,
            label: 'Operation',
        }],
    },
]
